import { getKeys } from './getKeys'

export const careOfficeAccessTranslations = {
  LOGO_ALT: 'Log my Care',
  NO_ACCESS_TITLE: "You can't use the Care Office",
  NO_ACCESS_BODY: "Your role doesn't have access to the Care Office.",
  NO_ACCESS_HINT:
    'Carers can keep using the Carer App. If you think this is wrong, ask your care provider to check your role.',
  NO_ACCESS_SIGN_OUT: 'Sign out'
}

export const careOfficeAccessConstants = getKeys(careOfficeAccessTranslations)
